import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { connect } from "react-redux";
import MainWrapper from "../wrappers/MainWrapper";
import CircularProgress from '@material-ui/core/CircularProgress';
import { Link } from "react-router-dom";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Button from '@material-ui/core/Button';

import FormControl from '@material-ui/core/FormControl';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Modal from '@material-ui/core/Modal';
import CustomTextField from "../../components/fields/CustomTextField";
import CheckboxGroup from "../../components/fields/CheckboxGroup";
import { reduxForm, Field, reset } from "redux-form";
import validateEmail from "../../utils/validateEmail";
import { fetchAllCompany,createNewUser ,checkUserRole,fetchAllUsers,editUserInfo,changeUserStat} from "../../actions";
import Snackbar from '@material-ui/core/Snackbar';
import NotificationSnackBar from '../../utils/NotificationSnackBar';
import PlusCircleIcon from '@material-ui/icons/AddCircle';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import EnhancedTableToolbar from '../../utils/EnhancedTableToolbar';
import UserTable from '../../utils/MainTable/UserTable';
import { userListStyle } from '../../utils/Style';
import UserListTable from '../../utils/MainTable/UserListTable';
import WorkIcon from '@material-ui/icons/Work';
import { FixedSizeList } from 'react-window';
import MenuItem from '@material-ui/core/MenuItem'; 
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText'; 

function getModalStyle() {
    return {
        top: `${50}%`,
        left: `${50}%`,
        transform: `translate(-${50}%, -${50}%)`,
    };
}

const required_fields = [
    { name: "description", label: "description" },
    { name: "expiryDay", label: "expiry day" },
    { name: "type", label: "type" },
];

const WAIT_INTERVAL = 1000;

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    root2: {
        width: '99%',
        maxWidth: 450,
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 300,
      },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto",
        color: "green"
    }
});
class NewUser extends React.Component {
    

    constructor(props, context) {
        super(props, context);
        this.state = {
            selected: [],
            open: false,
            isSwitchSnackbarOn: false,
           
            page: 0,
            rowsPerPage: 5,
            offset: 0,
            newUser:[],
            allComp:[],
            loading:false,
            contextChanged:true,
            selectedComp:0,
            username:'',
            pw:'',
            email:'',
            listUser:[],
            userRoles:{
                userRoles:[],
                error:null
            },
            updatedData:[],
            errorText:'',
            errorPwText:'',
            edited:null,

        }; 
        
        this.props.checkUserRole();
        this.getAllCompany();
    }

    componentDidMount(){
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today =yyyy + '-' +mm + '-' + dd ;
            //    this.props.checkfilestatus(today,today );
        this.setState({ loading: false,
            dateFrom: today,
            dateTo:today
        });
        
    }
   
    static getDerivedStateFromProps(props, state) { 
        let update = {};
        if(props.userRoles !== state.userRoles){
            update.userRoles = props.userRoles  
        } 
        if (props.retrieveCompstatus  !== state.retrieveCompstatus) {
            update.allComp = props.retrieveCompstatus;
            update.loading=false  ;
        }  

        if(props.editUser !== state.edited){
            console.log(props)
            update.edited = props.editUser;
            update.loading=false;
            update.isSnackbarError = props.editUser.isSnackbarError;
            update.isSwitchSnackbarOn =props.editUser.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.editUser.ErrorMessage;
        }

        if(props.newUser !== state.newUser){
            update.isSnackbarError = props.isSnackbarError;
            update.isSwitchSnackbarOn =props.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.ErrorMessage;
                update.newUser =props.newUser;
                update.loading=false;
             
        }

        if(props.listUser !== state.listUser){
            update.isSnackbarError = props.isSnackbarError;
            update.isSwitchSnackbarOn =props.isSwitchSnackbarOn;
            update.snackbarErrorMessage =props.ErrorMessage;
            update. listUser=props.listUser;
            update.loading=false ;
        }

        console.log(props.userRoles)
        console.log(state.userRoles)
        if(props.userRoles.success !== null)
        if(!props.userRoles.success){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
        }
        if(props.userRoles.userRoles.length !== state.userRoles.userRoles.length){ 
            if(props.userRoles.userRoles.length === 0){ 
            localStorage.clear(); 
            props.history.push("/signIn"); 
            }
        }

        return update;
    }
 

    updateSnackbarStatus = (snackbarObject) => {
        this.setState({
            isSnackbarError: snackbarObject.isSnackbarError,
            isSwitchSnackbarOn: snackbarObject.isSwitchSnackbarOn,
            snackbarErrorMessage: snackbarObject.ErrorMessage
        })
    }

    updateSnackbarStatusFalse = () => {
        if (this.state.isSwitchSnackbarOn) {
            this.setState({ isSwitchSnackbarOn: false })
        }
    }
    
    handleChange=(name)=>event =>{
        if(name === 'username'){
            if(!event.target.value.match(/^[a-z0-9]+$/i)){ 
                this.setState({errorText: 'Invalid character for username'}); 
            }
        }
          if(name === 'pw'){
            if(!event.target.value.match(/^[a-z0-9@]+$/i)){ 
                this.setState({errorPwText: 'Invalid character for password'}) 
            }
        }
        
            this.updateSnackbarStatusFalse(); 
            this.setState({[name]: event.target.value,
            contextChanged:true});
         
    }
    handleChangeCompany=event=>{
        this.setState({selectedComp: event.target.value});
    }

    handleEditedContent=(data)=>{
        console.log(data)
        this.setState({updatedData: data});
    }

    handleUpdateUserInfo=()=>{
        var updated = this.state.updatedData; 
        this.props.editUserInfo(updated);
    }
    
    handleChangeUserStatus =(uid)=>{
        this.props.changeUserStat(uid);
    }

    /*
    _handleSubmit = values => {
        this.handleModalClose();
        Object.assign(values, { id: this.state.id }, { keyword: '' }, { offset: this.setNewOffset(this.state.rowsPerPage, this.state.page) }, { limit: this.state.rowsPerPage });
        this.props.registerPackage(values, this.props.history);
    };
    handleModalOpen = (id, username) => {
        this.updateSnackbarStatusFalse();
        this.setState({
            id: id,
            username: username,
            open: true,
        });
    };

    handleModalClose = () => {
        this.setState({ open: false });
        this.props.reset();
    }; 
    handleActive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage);
    };

    handleInactive = () => {
        this.updateSnackbarStatusFalse();
        this.props.updateuserstoinactive(this.state.selected, this.state.searchVal, this.setNewOffset(this.state.rowsPerPage, this.state.page), this.state.rowsPerPage );
    };

    handleSelectAllClick = (event, checked) => {
        this.updateSnackbarStatusFalse();
        if (checked) {
            this.setState({ selected: this.state.users.map(n => n.id) });
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        this.updateSnackbarStatusFalse();
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(this.state.rowsPerPage, page), this.state.rowsPerPage);
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.updateSnackbarStatusFalse();
        this.props.fetchUser(this.state.searchVal,this.setNewOffset(event.target.value, this.state.page), event.target.value);
        this.setState({ rowsPerPage: event.target.value });
    };

    setNewOffset = (rowPerPage, page) => {
        return rowPerPage * page;
    }
*/
 
    getAllCompany=()=>{
        
        this.props.fetchAllCompany('');
    }
    handleSearch = event => {
        if(this.state.contextChanged){
            this.setState({ loading: true }); 
            this.updateSnackbarStatusFalse();   
        // this.setState({ searchVal: event.target.value })
        console.log(this.state.username)
            this.props.fetchAllUsers(this.state.username);
        }
    };


    submitNewUser =()=>{
        if(this.state.selectedComp === 0){

            return;
        }
        if(!this.state.username.match(/^[a-z0-9]+$/i))
        return;
        if(!this.state.pw.match(/^[a-z0-9@]+$/i))
        return;
        console.log(this.state.username);
        console.log(this.state.pw)
        var newUser={
            cid : parseInt(this.state.selectedComp),
            username: this.state.username,
            pw :this.state.pw, 
            email: this.state.email
        };

        this.setState({ loading: true }); 
        this.updateSnackbarStatusFalse(); 
        this.props.createNewUser(newUser);
    }

    render() { 

        const { classes } = this.props;
        const { users, order, orderBy, selected, rowsPerPage, page, offset, isSwitchSnackbarOn, isSnackbarError } = this.state;
      
        return (
            <MainWrapper
                history={this.props.history}
                isDisplayOn="none"
                userRoles={this.props.userRoles}>
          <Paper style={{marginTop:'10px',marginBottom:'10px'}}>
                <Grid container style={{padding:'10px'}}>
                <Grid container  >
                        <Grid item>
                        <EnhancedTableToolbar
                        tableName='Create New User' numSelected={0}
                    />
                        </Grid>
                        
                        <Grid item>
                            
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginLeft:'50px'}}>
                        <Grid item xs={1}>
                            Select Company
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink htmlFor="company-label-placeholder">
                            Company
                            </InputLabel>
                            <Select
                            value={this.state.selectedComp}
                            onChange={this.handleChangeCompany}
                            inputProps={{
                                name: 'company',
                                id: 'company-label-placeholder',
                            }}
                            name="company"
                            className={classes.selectEmpty}
                            >
                             {this.state.allComp.map(ei=>  
                                <MenuItem  value={''+ei.id} key={ei.id}>{ei.company_name} </MenuItem>  
                            )}
                            </Select>
                            <FormHelperText>Company</FormHelperText>
                        </FormControl>
                        
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                            New Username
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="username"
                                    label="Username"
                                    onChange={ this.handleChange('username')}
                                    error= {this.state.errorText}
                                    helper
                                />
                        </Grid>
                    </Grid>
                    <Grid container  style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                           New Password
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="pw"
                                    label="Password"
                                    type='password'
                                    onChange={ this.handleChange('pw')}
                                    error= {this.state.errorPwText}
                                />
                        </Grid>
                    </Grid> 
                    <Grid container  style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                           Email
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                            <TextField
                                    id="email"
                                    label="Email"
                                    type='email'
                                    onChange={ this.handleChange('email')}
                                />
                        </Grid>
                    </Grid> 
                    <Grid container style={{marginTop:'10px',marginLeft:'50px'}}>
                        <Grid item xs={1}>
                          
                        </Grid>
                        
                        <Grid item style={{padding:'10px'}}>
                        <Button  variant="contained"
                color="primary" onClick={()=>this.submitNewUser()}>Save</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper> 

                <Paper className={classes.root}>
                    <EnhancedTableToolbar
                        tableName='Search User' 
                        numSelected={0}
                    />
                    <div className={classes.search}>
                        <Grid container spacing={8} alignItems="flex-end">
                            <Grid item>
                                <SearchIcon />
                            </Grid>
                            <Grid item>
                            <TextField
                                id="Username"
                                label="Username"
                                defaultValue={this.state.username}//editUserInfo
                                InputLabelProps={{
                                shrink: true,
                                }} 
                                onChange={this.handleChange('username')}
                            />
                            </Grid>
                            <Grid item>
                                <Button  variant="outlined"
                                onClick={(e) => this.handleSearch(e) } >Search</Button>
                            </Grid>
                            
                        </Grid>
                    </div>
                    <div className={classes.tableWrapper}>
                    <Grid container >
                            <Grid item xs={12}>  
                                <UserListTable 
                                    data={this.state.listUser} 
                                    handleEditedContent={this.handleEditedContent}
                                    handleChangeUserStatus={this.handleChangeUserStatus}
                                />
                            </Grid> 
                            <Grid item xs={12}>
                                <Grid container justify='center' alignItems='center'>
                                    <Button
                                            className={classes.button}
                                            type="submit"
                                            variant="contained"
                                            color="primary"
                                            disabled={this.state.isSwitchSnackbarOn}
                                            onClick={this.handleUpdateUserInfo}
                                        >
                                            Save Edited info
                                        </Button> 
                                   
                                </Grid>
                        
                            </Grid>
                        </Grid>
                    </div>

                    <div className={classes.tableWrapper}>
                       
                    </div>
                    <NotificationSnackBar
                            isSwitchSnackbarOn={this.state.isSwitchSnackbarOn}
                            isSnackbarError={this.state.isSnackbarError}
                            snackbarErrorMessage={this.state.snackbarErrorMessage}
                    />
                </Paper> 
                {this.state.loading ? (
                <Grid container className={classes.root}>
                    <Grid item xs={12}>
                        <Grid container className={classes.loadingHeight} justify='center' alignItems='center'>
                            <CircularProgress color="primary" size={70} thickness={7} />
                        </Grid>
                    </Grid>
                </Grid>
            ) : null
            }
            </MainWrapper>
        );
    }
}

NewUser.propTypes = {
    classes: PropTypes.object.isRequired,
};

function validate(values) {
    const errors = {};

    
    return errors;
}

let SignInWithStyles = withStyles(styles)(NewUser);

SignInWithStyles = reduxForm({ 
    form: "newUserForm"
})(SignInWithStyles);


  //    getNotExpiredPackages={this.props.notexpiredpackagesResult}>

const mapStateToProps = ({ editUser, concessionUserReturn,retrieveComp ,userRoles}) => { 
    return {
        editUser:editUser,
        userRoles: userRoles,
        newUser: concessionUserReturn.new,
        allComp : retrieveComp,
        listUser : concessionUserReturn.listUser,
        retrieveCompstatus: retrieveComp.status,
    };
};

export default connect(
    mapStateToProps,
    { fetchAllCompany, createNewUser,checkUserRole,fetchAllUsers,editUserInfo,changeUserStat }
)(SignInWithStyles);





/*

                            <FormControl component="fieldset" className={classes.formControl}>
                                    <RadioGroup
                                        aria-label="Company"
                                        name="companies"
                                        className={classes.group}
                                        value={''+this.state.selectedComp}
                                        onChange={this.handleChangeCompany}
                                    >
                                    <List className={classes.root2}>
                                            {this.state.allComp.map(ei=> 
                                            <FormControlLabel
                                                value={''+ei.id}
                                                key={ ei.id}
                                                control={ 
                                                    <ListItem button  key={ei.id}> 
                                                    <Radio color="primary" value={''+ei.id}   />
                                                        <ListItemIcon>
                                                            <WorkIcon />
                                                        </ListItemIcon>
                                                        <ListItemText primary={ei.company_name} />
                                                    </ListItem> 
                                                    } 
                                                labelPlacement="start"
                                                /> 
                                            )}
                                    </List>
                                </RadioGroup>
                            </FormControl>


*/


// WEBPACK FOOTER //
// ./src/components/tabs/NewUser.js